import { FleekError } from './FleekError';

type InvalidTOTPTokenErrorOptions = {
  token: string;
};

export class InvalidTOTPTokenError extends FleekError<InvalidTOTPTokenErrorOptions> {
  public name = 'InvalidTOTPTokenError';

  toString = () => 'TOTP token is invalid.';
}
